import { ProductForSelection } from "./AutcompleteProductTypes";
import { AsyncAutocompleteFetchAdapter } from "../AutocompleteRoot";
import axios from "axios";

const fetchCache: Map<string, ProductForSelection[]> = new Map();

export class ControllerAutocompleteProductFetch implements AsyncAutocompleteFetchAdapter<ProductForSelection> {
  constructor(private async_url: string) {}

  async search(searchValue?: string | undefined): Promise<ProductForSelection[]> {
    const key = this.async_url + searchValue;
    if (fetchCache.has(key)) {
      return fetchCache.get(key)!;
    }
    const response = await axios.post(`${this.async_url}/search`, {
      search: searchValue,
    });
    if (response.data?.data) {
      fetchCache.set(key, response.data.data);
    }
    return response.data.data;
  }

  async fetchInitialValue(
    id: string | number | number[] | string[]
  ): Promise<ProductForSelection | ProductForSelection[] | undefined> {
    if (typeof id !== "number" && id.length === 0) {
      return;
    }

    const response = await axios.post(`${this.async_url}/fetchInitial`, {
      id,
    });

    return response.data.data;
  }
}
